import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import {
    Icon,
    Switch,
} from '@blueprintjs/core';
import {
    Alignment,
    IconSize,
} from '@blueprintjs/core';
import {
    IconNames
} from '@blueprintjs/icons';
import { Tooltip2 } from '@blueprintjs/popover2';
import { setDarkMode } from '$root/store/actions';

function DarkModeSwitch({ large = false }) {

    const dispatch = useDispatch();
    const darkMode = useSelector(state => state.ui.darkMode)

    return (
        <div style={{
            display: 'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent: 'end',
            width: '100%',
        }}>
            {/*<Icon icon={IconNames.FLASH} size={IconSize.STANDARD} />*/}
            <Tooltip2 content={'dark/light'}>
                <Switch large={large}
                        alignIndicator={Alignment.CENTER}
                        checked={darkMode}
                        onChange={(evt) => {
                            dispatch(setDarkMode(!darkMode));
                        }}
                />
            </Tooltip2>
            {/*<Icon icon={IconNames.MOON} size={IconSize.STANDARD} />*/}
        </div>
    );
}

export default DarkModeSwitch;